import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 12.19C8.00018 12.3888 8.07931 12.5795 8.22 12.72L13.36 17.85C13.4065 17.8968 13.4618 17.934 13.5227 17.9594C13.5836 17.9848 13.649 17.9979 13.715 17.9979C13.781 17.9979 13.8464 17.9848 13.9073 17.9594C13.9682 17.934 14.0235 17.8968 14.07 17.85L14.78 17.15C14.8269 17.1035 14.8641 17.0482 14.8894 16.9873C14.9148 16.9263 14.9279 16.861 14.9279 16.795C14.9279 16.729 14.9148 16.6636 14.8894 16.6027C14.8641 16.5418 14.8269 16.4865 14.78 16.44L10.33 12L14.78 7.55997C14.8266 7.51435 14.8636 7.4599 14.8888 7.3998C14.9141 7.3397 14.9271 7.27516 14.9271 7.20997C14.9271 7.14478 14.9141 7.08025 14.8888 7.02015C14.8636 6.96005 14.8266 6.9056 14.78 6.85997L14.07 6.14997C14.0235 6.10311 13.9682 6.06591 13.9073 6.04053C13.8464 6.01514 13.781 6.00208 13.715 6.00208C13.649 6.00208 13.5836 6.01514 13.5227 6.04053C13.4618 6.06591 13.4065 6.10311 13.36 6.14997L8.22 11.28C8.08112 11.4217 8.0023 11.6116 8 11.81V12.19Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgLeftOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgLeftOutline;
